module.exports = __webpack_public_path__ + "img/life-milestone.316ef19e.jpg";